// REMIX HMR BEGIN
import * as __hmr__ from "remix:hmr";
if (import.meta) {
import.meta.hot = __hmr__.createHotContext(
//@ts-expect-error
"app/routes/events.request.tsx"
);
import.meta.hot.lastModified = "1740183864617.7148";
}
// REMIX HMR END

import { ActionFunctionArgs } from "@remix-run/cloudflare";
import { makeDomainFunction } from "domain-functions";
import { z } from "zod";
import { formAction } from "~/components/forms/form-action.server";
import { sendEventsRequest } from "~/services/airtable.server";
import { checkHoneypot } from "~/utils/honeypot.server";

export const schema = z.object({
  name: z
  .string()
  .min(1, {
    message: "This field is required.",
  })
  .min(3, {
    message: "Please use at least 3 characters.",
  }),
  email: z.string().min(1, { message: "This field is required." }).email({
    message: "Write a valid email.",
  }),
  company: z.string().min(1, { message: "This field is required." }),
  role: z
    .enum([
      "Select an option",
      "C-Level",
      "Director / Lead",
      "Developer",
      "Marketing",
      "Other",
    ])
    .default("Select an option")
    .refine((value) => value !== "Select an option", {
      message: "Please select an option.",
    }),
    hearAbout: z
      .enum([
        "Select an option",
        "At an event",
        "By email",
        "In a blog post",
        "On social media",
        "Someone mentioned it to me",
        "Other",
      ])
      .default("Select an option")
      .refine((value) => value !== "Select an option", {
        message: "Please select an option.",
      }),
});

const environmentSchema = z.object({
  AIRTABLE_API_KEY: z.string(),
  AIRTABLE_BASE_ID: z.string(),
});

const mutation = makeDomainFunction(
  schema,
  environmentSchema
)(async ({ company, role, hearAbout, email, name }, context) => {
  await sendEventsRequest(
    {
      company,
      role,
      hearAbout,
      email,
      name,
    },
    context as any
  );

  return {
    success: true,
  };
});

export const action = async ({
  request,
  context: environment,
}: ActionFunctionArgs) => {
  const formData = await request.clone().formData();
  await checkHoneypot(formData, environment.HONEYPOT_SEED as string);
  return await formAction({
    request,
    schema,
    mutation,
    environment,
  });
};
